<template>
  <div class="headStyle">
    <div class="firstRowStyle">
      <div class="systemStyle">

        <div>打分测评小程序</div>
        <div class="systemStyle"><div style="font-size: 14px;">自评互评，保护隐私，自动计算，自动汇总！</div></div>
      </div>
      <div class="infoActionStyle">
        <el-button @click="logout" type="text" size="medium">
          <span  style="text-decoration: underline;">退出</span>
        </el-button>
      </div>
    </div>
    <div>


      <el-dialog width="25%" :close-on-click-modal="false" title="修改用户资料" :visible.sync="editDialogVisible">
        <!-- <el-form-item label="卷面分"> -->
        <div class="colStyle">
          <div class="rowStyle">
            <div  class="rowStyle" style="padding-right: 10px;white-space:nowrap;"><div>{{lable}}</div></div>
            <div>
              <el-input v-model="content" autocomplete="off" placeholder="数字,如150" autofocus></el-input>
            </div>
          </div>
        </div>

        <!-- </el-form-item> -->

        <div slot="footer" class="dialog-footer">
          <el-button @click="cacelEdit">取 消</el-button>
          <el-button type="primary" @click="saveContent">保 存</el-button>
        </div>
      </el-dialog>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        username: '',
        name: '',
        school: '',
        content: '',
        lable: '',
        source: '',
        editDialogVisible: false,
        url: this.HOST_URL + '/images/logo.jpg'
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.name = this.$session.get('NAME') // 获取session
    },
      mounted() {
      console.log('monted:' + this.username)
      if (this.isEmpty(this.username)) {
        this.$router.push('/')
      }
      },
    methods: {
      logout() {
        let that = this

        this.$confirm('要退出系统吗?', '提示', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/evaluations/web/_logout.jsp'
          this.axios.get(requestUrl, {
              params: {
                username: that.username
              }
            }).then(function(response) {
              that.$session.set('USERNAME', '')
              that.$router.push('/')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      helpMe() {
        const {
          href
        } = this.$router.resolve({
          name: 'help'
        })
        window.open(href, '_blank')
      },
      editProfile(source) {
        if (source === 'school_name') {
          this.content = this.school
          this.lable = '学校'
          this.source = 'school_name'
        } else {
          this.content = this.teacher_name
          this.lable = '姓名'
          this.source = 'teacher_name'
        }

        this.editDialogVisible = true
      },
      cacelEdit() {
        this.editDialogVisible = false
      },
      saveContent() {
        // 校验
        if (this.content === '') {
          this.$message.error('内容不能为空！')
          return
        }

        let that = this
        var requestUrl = '/wansearch/web/_update_profile.jsp'

        if (this.source === 'school_name') {
          this.school = this.content
          that.$session.set('SCHOOL', this.content) // 存session
        } else {
          this.teacher_name = this.content
          that.$session.set('TEACHER_NAME', this.content) // 存session
        }

        // 设置session

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              content: that.content,
              source: that.source
            }
          }).then(function(response) {
            // that.columNames.push(...response.data)
            that.content = ''
            that.editDialogVisible = false
            that.$message('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      }

    }
  }
</script>

<style>
  .headStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1upx solid #E9ECF1;
    background-color: aliceblue;

  }

  .firstRowStyle {
    display: flex;
    justify-content: space-between;
    /* background-color: #f2f2f2; */
    width: 99%;
  }

  .systemStyle {
    display: flex;
    font-size: 30px;
    padding: 20px;
    font-weight: bold;
  }

  .infoActionStyle {
    display: flex;
    padding-right: 20px;
    align-items: center;
  }

  .rowStyle{
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/head.vue